import { BankInterfaceMonitoringMaintenanceConstant } from "presentation/constant/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useBankInterfaceMonitoringMaintenanceVM } from "presentation/hook/BankInterfaceMonitoring/useBankInterfaceMonitoringMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useBankInterfaceMonitoringMaintenanceTracked } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const BankInterfaceMonitoringTitleBar: React.FC = () => {
    const [bankInterfaceMonitoringState] = useBankInterfaceMonitoringMaintenanceTracked();;
    const bankInterfaceMonitoringVM = useBankInterfaceMonitoringMaintenanceVM();
    const messageBarVM = useMessageBarVM();

    const [isLoading, setIsLoading] = useState(false);
    const { bankInterfaceMonitoringEtys, isShowRightPanel, searchCriteria } = bankInterfaceMonitoringState;
    const [anaInfoState] = useANAInfoTracked();

    const { allowUpdate } = anaInfoState;

    const handleSearchClick = useCallback(() => {
        bankInterfaceMonitoringVM.onSearchClick();
    }, [bankInterfaceMonitoringVM]);


    const handleResentAllClick = useCallback(async () => {
        if (!bankInterfaceMonitoringEtys) {
            messageBarVM.showError("Please search for INV messages first.");
            return;
        }
        const messageTypeINVRows = bankInterfaceMonitoringEtys?.filter(row => row.messageType === 'INV' && (row.status === 'REJECT' || row.status === 'ERROR'));
        if (messageTypeINVRows.length < 1) {
            messageBarVM.showError("No INV messages can be resend.");
            return;
        }
        setIsLoading(true);

        bankInterfaceMonitoringVM.onResendAll(messageTypeINVRows).then((data) => {
            if (data.success) {
                messageBarVM.showSuccess("Resend Successfully.");
                bankInterfaceMonitoringVM.onSearch(searchCriteria).then(() => {
                    setIsLoading(false);
                }).catch((error) => {
                    setIsLoading(false);
                });
            } else {
                messageBarVM.showError(data.data ?? "Resend Failed.");
                setIsLoading(false);
                return;
            }
        }).catch((error) => {
            setIsLoading(false);
            messageBarVM.showError('Resend Failed.');
        });
        setIsLoading(false);

    }, [bankInterfaceMonitoringVM, searchCriteria, bankInterfaceMonitoringEtys, messageBarVM]);

    const isResendDisable = () => {
        if (!isShowRightPanel && bankInterfaceMonitoringEtys) return false
        return true;
    }

    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{BankInterfaceMonitoringMaintenanceConstant.TITLE}</HeaderTitle>
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={isShowRightPanel} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearchClick} />

            {allowUpdate && <HPHButton label={WorkspaceConstant.Common.BUTTON_RESEND_ALL} disabled={isResendDisable()} size={'Small'} theme={'Primary'} onClick={handleResentAllClick} />}
        </StyledAction>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
    </Sidebarheader>
}

export default memo(BankInterfaceMonitoringTitleBar);